import { TranslatePipe } from '../../filters/translate.pipe';
import { ElementRef } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularHelperService from '../../services/angular-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'input-autocomplete',
	templateUrl: './input-autocomplete.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class InputAutocompleteComponent implements OnInit, OnDestroy {
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() isRequired?: boolean;
	@Input() displayPlaceHolder: any | undefined;
	@Input() opts: any | undefined;
	@Input() minLength: any | undefined;
	@Input() name: any | undefined;
	@Input() model: any;
	@Output() modelChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() disabled?: boolean;
	@Input() id: any | undefined;
	@Input() isSmall: any | undefined;
	@Input() searchFn: (searchTerm: any) => void;
	@Input() selectFn: (selectedItem: any) => void;
	@Input() clearFn: () => void;
	
	vm: any = undefined;
	
	constructor(private elementRef: ElementRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.isActive = false;
		this.vm.searchInterval = 250;
		this.vm.minLength = this.vm.minLength || 0;
		
		// this.angularStateHelperService.scopeWM(this, 'this.vm.model', this.handleInputUpdate);
		if (this.vm.model) {
			this.handleInputUpdate();
		}
		
		this.vm.handleInputChange = this.handleInputChange;
		this.vm.handleInputFocus = this.handleInputFocus;
		this.vm.handleInputReset = this.handleInputReset;
		this.vm.handleInputBlur = this.handleInputBlur;
		this.vm.handleInputKeydown = this.handleInputKeydown;
		this.vm.handleItemSelect = this.handleItemSelect;
		this.vm.handleItemActive = this.handleItemActive;
		this.vm.handleItemsInactive = this.handleItemsInactive;
		this.vm.isValidPictureUrl = this.isValidPictureUrl;
	}
	
	ngOnDestroy() {
		if (this.vm.searchTimer) this.angularHelperService.cancelTimer(this.vm.searchTimer);
	}

	handleInputFocus() {
		this.vm.isActive = true;
		this.vm.term = undefined;
		this.handleInputChange();
	}
	
	handleInputReset() {
		this.vm.term = undefined;
		this.vm.model = undefined;
		this.elementRef.nativeElement.querySelector('input').focus();
		if (this.vm.clearFn) {
			this.vm.clearFn();
		}
	}

	handleInputUpdate() {
		this.vm.term = (!this.vm.model || !this.vm.model.id) ? undefined : this.vm.model.name;
	}
	
	handleInputBlur(reset?) {
		if (!this.vm.isActive) return;
		
		if (reset) this.vm.isActive = false;
		this.vm.items = undefined;
		this.vm.isSearching = false;
		
		if (!this.vm.model || this.vm.model.name !== this.vm.term) {
			this.vm.term = undefined;
			this.vm.model = undefined;
		}
	}
	
	isValidPictureUrl(pictureUrl) {
		return pictureUrl && pictureUrl.startsWith('http');
	}
	
	handleInputChange() {
		this.vm.model = undefined;
		this.vm.isSearching = true;
		var searchTimerDelay: any = this.vm.searchTimer ? this.vm.searchInterval : 0;
		
		if (this.vm.searchTimer) this.angularHelperService.cancelTimer(this.vm.searchTimer);
		if (this.vm.minLength && (!this.vm.term || (this.vm.term.length < this.vm.minLength))) {
			this.vm.items = undefined;
			this.vm.isSearching = false;
			return;
		}
		
		this.vm.searchTimer = this.angularHelperService.createTimer(() => {
			var params: any = this.vm.opts || {};
			params.namePart = this.vm.term;
			
			var promise: any = this.vm.searchFn(params);
			
			if (!promise) {
				this.vm.items = undefined;
				this.vm.isSearching = false;
				return;
			}
			
			promise.then((items) => {
				if (!this.vm.isActive) return;
				this.vm.items = items;
				this.vm.isSearching = false;
			})
			.catch((err) => {
				this.vm.items = undefined;
				this.vm.isSearching = false;
				console.error(err);
			});
		}, searchTimerDelay);
	}
	
	handleInputKeydown(e) {
		var keyCode: any = e.which || e.keyCode;
		switch (keyCode) {
			case 9:
			case 13:
				if (!this.vm.items || !this.vm.items.length) return;
				var activeItem: any = this.vm.items.filter(function(item) { return item.active; })[0];
				this.handleItemSelect(activeItem);
				break;
			case 38:
				this.handleItemActivePrevious();
				break;
			case 40:
				this.handleItemActiveNext();
				break;
		}
	}
	
	handleItemSelect(item) {
		if (!item) return;
		
		// TODO ANGULAR_2: why is this additional hack now needed?
		if (item.dialCode) {
			item.name = item.dialCode;
		}
		
		this.vm.model = item;
		this.vm.term = this.vm.model.name;
		if (this.vm.selectFn) {
			this.vm.selectFn({selectedItem: item});
		}
		this.modelChange.emit(item);
		
		this.handleInputBlur();
	}
	
	handleItemsInactive() {
		this.vm.items.forEach(function(item) { item.active = false; });
	}
	
	handleItemActive(item) {
		this.vm.items.forEach(function(i) { i.active = i.id === item.id; });
	}
	
	handleItemActivePrevious() {
		if (!this.vm.items || !this.vm.items.length) return;
		var currentIndex: any = Math.max(0, this.vm.items.findIndex(function(item) { return item.active; }));
		var newIndex: any = currentIndex ? currentIndex - 1 : this.vm.items.length - 1;
		this.handleItemActive(this.vm.items[newIndex]);
	}
	
	handleItemActiveNext() {
		if (!this.vm.items || !this.vm.items.length) return;
		var currentIndex: any = this.vm.items.findIndex(function(item) { return item.active; });
		if (currentIndex < 0) currentIndex = this.vm.items.length - 1;
		var newIndex: any = currentIndex >= this.vm.items.length - 1 ? 0 : currentIndex + 1;
		this.handleItemActive(this.vm.items[newIndex]);
	}
	
}